import connect from 'react-redux/es/connect/connect';
import { withTheme } from '@material-ui/styles';
import CustomBooking from './CustomBooking';
import { setCustomBooking, setHasCustomBooking, updateCartItem } from '../../../actions/cart';

const mapStateToProps = state => {
    return {
        cartItems: state.cart.cartItems
    };
};

const mapDispatchToProps = dispatch => ({
    setCustomBooking: (cartitemIndex, customBooking) => {
        dispatch(setCustomBooking(cartitemIndex, customBooking));
    },
    setHasCustomBooking: (cartitemIndex, hasCustomBooking) => {
        dispatch(setHasCustomBooking(cartitemIndex, hasCustomBooking));
    },
    updateCartItem: (cartitemIndex, cartitem) => {
        dispatch(updateCartItem(cartitemIndex, cartitem));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(CustomBooking));
